import React, { useImperativeHandle, forwardRef } from "react";

import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Paper, Grid, Typography } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import CreativeNameManager from "../../CreativeNameGenerator/CreativeNameManager";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    // border: "1px solid rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  paper2: {
    padding: 0,
    textAlign: "center",
    color: theme.palette.text.secondary,
    border: "none",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

let RMTypes = [
  "RICH_MEDIA_DISPLAY_BANNER",
  "RICH_MEDIA_DISPLAY_EXPANDING",
  "RICH_MEDIA_DISPLAY_INTERSTITIAL"
];

export default forwardRef(
  ({ isClickEnabled, isDragDisabled, isThumbnailEnabled }, ref) => {
    const classes = useStyles();

    let creatives = useSelector((state) => state.creatives);

    useImperativeHandle(ref, () => ({
      validate() {
        let creativeList = Object.values(creatives.byId);

        for (let i = 0; i < creativeList.length; i++) {
          if (!creativeList[i].taxonomy.name) {
            return {
              hasErrors: true,
              message: "You need to add naming for each asset."
            };
          }
          
          if (
            creativeList[i].dcmCreative !== undefined &&
            creativeList[i].dcmCreative.hasOwnProperty("clickTags")
            ) {
            if (RMTypes.includes(creativeList[i].dcmCreative.type)) {
              return {
                hasErrors: false,
                message: ""
              }
            }
            if (!creativeList[i].dcmCreative.clickTags[0].clickThroughUrl) {
              return {
                hasErrors: true,
                message: "You need to set click through url for each asset."
              };
            }

            if (!creativeList[i].taxonomy.urlId) {
              return {
                hasErrors: true,
                message: "You need to set click through url for each asset."
              };
            }
          }

        }

        return {
          hasErrors: false,
          message: ""
        };
      }
    }));

    return (
      <React.Fragment>
        <Typography variant="h6" className={classes.h6}>
          Generate name/assign URL for each creative
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <HorizontalAssetList
              isClickEnabled={isClickEnabled}
              isDragDisabled={isDragDisabled}
              isThumbnailEnabled={isThumbnailEnabled}
              isWeightEnabled={false}
            />
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paper2}>
              <CreativeNameManager standalone={false} />
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
);
